<kendo-card class="summary-card" width="auto" [class.warning-card]="$hasWarning()">
  <kendo-card-body>
    <h4>{{ $displayName() }}</h4>
    <h3>
      @if ($isLoading()) {
        <kendo-skeleton [width]="30" />
      } @else {
        {{ $displayText() }}
      }
    </h3>
  </kendo-card-body>
</kendo-card>
